





















Prismic = require 'prismic-javascript'
prismic = require '@/utils/prismic/api'
{ textOf } = require '@/utils/prismic/utils'
PrismicDOM = require 'prismic-dom'

module.exports =
	components:
		'home-marquee': require './marquee'
		'clients': require './clients'
		'what': require './what'
		'about': require './about'
		'contact': require './contact'

	data: ->
		homeEls: null
		clients: null
		capabilities: null
		people: null

	created: ->
		@getHomeEls()
		@getClients()
		@getCapabilities()

	methods:
		getHomeEls: ->
			prismic (api) => api.getSingle('home')
				.then (response) => @homeEls = response.data

		getClients: ->
			prismic (api) => api.query(
				Prismic.Predicates.at('document.type', 'client'),
			).then (response) => @clients = response.results

		getCapabilities: ->
			prismic (api) => api.query(
				Prismic.Predicates.at('document.type', 'capability'),
			).then (response) => @capabilities = response.results





// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home/index.vue